import { unwrapResult } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';
import { FEATURE_ABANDONED_CARTS_AUTOMATED_EMAILS } from 'App/features';
import { useAppDispatch } from 'App/store';
import { useStatusFeatureByKey } from 'domains/Auth/hooks';
import {
  AbandonedCartEmalConfg,
  updateAbandonedCartsEmailConfig,
} from 'domains/Orders/AbandonedCart/abandonedCartsSlice';
import {
  getAbandonedCartEmailConfig,
  getAbandonedCartEmailStatus,
} from 'domains/Orders/AbandonedCart/abandonedCartsSlice/abandonedCartsSelectors';

interface UseAbandonedCartConfigEmailResult {
  abandonedCartEmailConfig: AbandonedCartEmalConfg;
  isLoading: boolean;
  updateEmailConfig: (config: AbandonedCartEmalConfg) => void;
}

function useAbandonedCartConfigEmail(): UseAbandonedCartConfigEmailResult {
  const dispatch = useAppDispatch();

  const { isAvailable } = useStatusFeatureByKey(
    FEATURE_ABANDONED_CARTS_AUTOMATED_EMAILS,
  );

  const abandonedCartEmailConfig = useSelector(getAbandonedCartEmailConfig);

  const realAbandonedCartEmailConfig = !isAvailable
    ? 'manual'
    : abandonedCartEmailConfig;

  const { isLoading } = useSelector(getAbandonedCartEmailStatus);

  const updateEmailConfig = async (config: AbandonedCartEmalConfg) => {
    unwrapResult(await dispatch(updateAbandonedCartsEmailConfig(config)));
  };

  return {
    abandonedCartEmailConfig: realAbandonedCartEmailConfig,
    isLoading,
    updateEmailConfig,
  };
}

export default useAbandonedCartConfigEmail;
